export default "__VITE_ASSET__b219b3a4__"